export default "__VITE_ASSET__2666a62c__"